// @flow

import nullLaf from '@tectonics/look-and-feel/null';
import shopifyEmbeddedLaf from '@tectonics/look-and-feel/shopify-embedded';
import shopifyLaf from '@tectonics/look-and-feel/shopify';
import uberLaf from '@tectonics/look-and-feel/uber';
import volcanesLaf from '@tectonics/look-and-feel/volcanes';
import uberV2Laf from '@tectonics/look-and-feel/uber-v2';

export const LOOK_AND_FEELS = [
  nullLaf,
  shopifyEmbeddedLaf,
  shopifyLaf,
  uberLaf,
  volcanesLaf,
  uberV2Laf,
];

export const DEFAULT_LOOK_AND_FEEL = volcanesLaf;
